import classnames from 'classnames';
import React, { Component, Fragment } from 'react';
import { ButtonGroup } from 'react-bootstrap';
import { Col, Form, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { ArcaHttpClientList } from '../../code/ArcaHttpClientList';
import { ArcaHttpClientPet } from '../../code/ArcaHttpClientPet';
import { ArcaHttpClientQuestions } from '../../code/ArcaHttpClientQuestions';
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { CalendarPanel } from './Calendar/CalendarPanel';
import { ArcaLink } from './Fields/ArcaLink';
import { ModalPopup } from './ModalPopup';
import { PhotoUploadAndShowPanel } from './PhotoPanel/PhotoUploadAndShowPanel';
import { StatusBar } from './StatusBar';
import { TableSimpleRow } from './TableSimpleRow';

export class PetPanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: this.props.person.State === 'Registered' ? 'Sessions' : 'Details',
            sessions: [],
            activities: null,
            imageFolder: `pets`,
            questions: null,
            fluff: Date.now(),
            deletePopupOpen: false,
            petDeletedLocally: false
        };
    }

    async componentDidMount() {
        await ArcaHttpClientList.GetAsync(
            'TimeslotType',
            this.receivedSesstionsSlots.bind(this))

        await ArcaHttpClientList.GetWithCodesAsync(
            'ActivityType',
            this.receivedActivitiesList.bind(this))

        this.getTheQuestionsAsync(this.props.pet.Code)
    }



    async getTheQuestionsAsync(petType) {

        await ArcaHttpClientQuestions.GetByFormAsync(
            (petType === 'Dog' ? 'DogDetails' : 'PetDetails'),
            ((questions) => {
                this.setState({ questions });

            }),
            (txt) => this.setState({ isError: true, statusText: txt })
        );
    }

    receivedSesstionsSlots(list) {
        this.setState({ sessions: list });
    }

    receivedActivitiesList(list) {
        this.setState({ activities: list });
    }

    toggle(tab) {
        this.setState({ activeTab: tab });
    }

    render() {
        let { imageFolder, questions, activeTab, deletePopupOpen, statusText, isError, petDeletedLocally } = this.state;
        let { pet, person } = this.props;

        return (
            <Form>

                <h1 className='centerText'>{pet.FullName}</h1>

                <Nav tabs className='dg-dark'>

                    {person.State === 'Registered'
                        ? <NavItem key='Sessions'>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'Sessions' })}
                                onClick={() => this.toggle('Sessions')}>
                                Bookings
                            </NavLink>
                        </NavItem>
                        : null}

                    <NavItem key='Details'>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'Details' })}
                            onClick={() => this.toggle('Details')}>
                            {pet.FullName}&apos;s Details
                        </NavLink>
                    </NavItem>

                    <NavItem key='PhotoUpload'>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'PhotoUpload' })}
                            onClick={() => this.toggle('PhotoUpload')}>
                            Photo
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId='Details'>
                        {activeTab === 'Details'
                            ? <Row>
                                <Col>
                                    <StatusBar message={statusText} isError={isError} />
                                    {!petDeletedLocally
                                        ? <div className='centerText'>
                                            <ButtonGroup>
                                                <ArcaLink
                                                    width={'175px'}
                                                    text="Edit"
                                                    link={'/PetEdit?id=' + pet.Id + '&personid=' + pet.OwnerId} />
                                                <ArcaLink
                                                    width={'175px'}
                                                    text="Delete"
                                                    onClick={() => this.setState({ deletePopupOpen: true })}
                                                />
                                            </ButtonGroup>
                                        </div>
                                        : null}

                                    <table className='table table-striped' aria-labelledby="tabelLabel">
                                        <tbody>

                                            {ArcaSecurity.IsAdmin
                                                ? <TableSimpleRow title='Arca Notes' text={pet.ArcaNotes} />
                                                : null}

                                            <TableSimpleRow title='Name' text={pet.FullName} />
                                            <TableSimpleRow title='Activity' text={pet.Activity} />
                                            <TableSimpleRow title='Breed' text={pet.Breed} />
                                            <TableSimpleRow title='Default timeslot' text={pet.Timeslot} />
                                            <TableSimpleRow title='Duration of walk' text={pet.Duration} />
                                            <TableSimpleRow title='Feeding' text={pet.Feeding} />
                                            <TableSimpleRow title='Best walk' text={pet.BestWalk} />
                                            <TableSimpleRow title='Lead details' text={pet.Lead} />
                                            <TableSimpleRow title='On/off lead' text={pet.OnOffLead} />
                                            <TableSimpleRow title='Notes' text={pet.Notes} />
                                            {questions?.map((q, k) =>
                                                <Fragment key={k} >
                                                    {pet.Answers[q.Code] !== ''
                                                        ? <TableSimpleRow title={q.Label} text={pet.Answers[q.Code]} />
                                                        : null}
                                                </Fragment>)}


                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                            : null}
                    </TabPane>

                    {person.State === 'Registered'
                        ? <TabPane tabId="Sessions">
                            {activeTab === 'Sessions'
                                ? <Fragment>
                                    <Row>
                                        <Col>
                                            {this.state.activities
                                                ? <CalendarPanel
                                                    type='DogGroup'
                                                    id={pet.Id}
                                                    sessions={this.state.sessions}
                                                    onCalendarChange={this.props.onCalendarChange}
                                                    activities={this.state.activities} />
                                                : 'Loading calendar ...'}
                                            <hr />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            AM  - (9am - 11am) <br />
                                            AM/MID - Morning or Midday<br />
                                            Mid - (11am - 1pm) <br />
                                            MID/PM - Midday or Afternoon<br />
                                            PM  - (1am - 3pm)
                                        </Col>
                                        <Col>
                                            {this.state.activities?.map((a, k) =>
                                                <span key={k}>{a.Code} - {a.Description} <br /></span>
                                            )}
                                        </Col>
                                    </Row>
                                </Fragment>
                                : null}
                        </TabPane>
                        : null}

                    <TabPane tabId="PhotoUpload">
                        {activeTab === 'PhotoUpload'
                            ? <PhotoUploadAndShowPanel folder={imageFolder} id={pet.Id} />
                            : null}
                    </TabPane>
                </TabContent>

                {deletePopupOpen
                    ? <ModalPopup
                        onConfirm={() => this.deletePet(pet)}
                        onCancel={() => this.setState({ deletePopupOpen: false })}
                        title={`Delete '${pet.FullName}' completely`}
                        text={`Are you really sure you want to remove '${pet.FullName}'. There is not coming back.`} />
                    : null
                }
            </Form>
        );
    }

    async deletePet(pet) {
        await ArcaHttpClientPet.DeleteAsync(
            pet,
            (() => {
                this.setState({ isError: false, statusText: 'Your pet has been deleted', deletePopupOpen: false, petDeletedLocally : true });
            }),
            (() => this.setState({ isError: true, statusText: 'Could not delete your pet', deletePopupOpen: false}))
        );
    }
}